export default __webpack_public_path__ + "static/media/notes_icon.9ef4d970.svg";